import React from 'react';
import { mealPlaceholderImage } from '@front-activerse/common-components';
import { UnifiedMealData } from '../../types';

interface TrackerMealImageProps {
  mealData: UnifiedMealData;
  appBrand: string;
}

const TrackerMealImage: React.FC<TrackerMealImageProps> = ({ mealData, appBrand }) => {
  let mealImg: string;
  if (mealData.preparationImageUrl) {
    mealImg = mealData.preparationImageUrl;
  } else if (mealData.mealType !== undefined) {
    mealImg = mealPlaceholderImage(mealData.mealType, appBrand);
  } else {
    mealImg = mealData.preparationImageUrl ?? '';
  }
  return (
    <img src={mealImg} className="img-fluid rounded mb-3 mb-md-0" width="502" height="502" alt="" />
  );
};

export default TrackerMealImage;
